import { ThemeProvider } from '@emotion/react';
import { CssBaseline } from '@mui/material';
import { FallbackComponent, I18nWrapper, setupDatadogRum, store, theme } from 'common-ui';
import { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { RouterProvider } from 'react-router-dom';
import reportWebVitals from './reportWebVitals';
import { createAppRouter } from './router';

setupDatadogRum();

const router = createAppRouter();

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <Provider store={store}>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Suspense fallback={<FallbackComponent requesting overlay />}>
        <I18nWrapper>
          <RouterProvider router={router} />
        </I18nWrapper>
      </Suspense>
    </ThemeProvider>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
